import {Checkbox} from '@mui/material';
import {type TradableSymbol} from '@qep/types/src';
import React, {type ChangeEvent} from 'react';

type DefaultIcebergSetterProps = {
  tradableSymbol: TradableSymbol;
  handleChange: (value: boolean, sym: TradableSymbol) => void;
};

const DefaultIcebergSetter: React.FC<DefaultIcebergSetterProps> = ({
  tradableSymbol: symbol,
  handleChange,
}: DefaultIcebergSetterProps) => {
  const onIcebergChanged = (_event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
    handleChange(checked, symbol);
  };

  return (
    <Checkbox
      checked={Boolean(symbol.isIceberg)}
      className='iceberg-checkbox'
      data-testid='iceberg-checkbox'
      onChange={onIcebergChanged}
    />
  );
};

export default DefaultIcebergSetter;
